import React from 'react'

export default class SkeletonInsuranceCard extends React.Component {
  render () {
    return <div className='insurance-card skeleton' />
  }
}
